module.exports = __webpack_public_path__ + "static/media/Workout-Duration.30b79493.png";